<div class="row">
  <div class="col">
    <el-multi-field
      title="{{ contactNumber.label }}"
      placeholder="{{ contactNumber.placeholder }}"
      [required]="contactNumber.isRequired"
      (onSetValue)="onComplexFieldSetClicked($event)"
      [data]="{
        type: 'PHONE',
        value: value,
        fieldConfig: value
      }"
    >
    </el-multi-field>
  </div>
</div>
